import { Button } from '@arco-design/web-react';
import { IconPlus } from '@arco-design/web-react/icon';
import React from 'react';
import { getButtonColor, getButtonTextColor } from '../../../../utils/cssVariables';

type Props = {
  onClick?: () => void;
};

export function NewChatButton({ onClick }: Props) {
  return (
    <Button
      style={{
        color: getButtonTextColor(),
        backgroundColor: getButtonColor(),
      }}
      className="add-contact-button"
      size="large"
      shape="circle"
      onClick={onClick}
    >
      <IconPlus fontSize={24} />
    </Button>
  );
}